class MedicalItem {
  constructor(title, code) {
    this.title = title;
    this.code = code;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      medicalItemId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      medicalItemManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'کد', value: 'code', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchText: '',
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن اقلام مصرفی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش اقلام مصرفی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getMedicalItemFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.medicalItem = new MedicalItem('', '');
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addMedicalItemFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش اقلام مصرفی';
        this.$refs.confirm.text = 'از ویرایش اقلام مصرفی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف اقلام مصرفی';
        this.$refs.confirm.text = 'از حذف اقلام مصرفی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addMedicalItemFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editMedicalItemFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteMedicalItemFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.medicalItemId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfMedicalItemsWithPagination();
    },
    removeFilters: function () {
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfMedicalItemsWithPagination();
    },
    cancelSearch: function () {
      this.searchText = '';
      this.searchModal = false;
    },
  },
};
